import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const PaymentReconciliationRecordList = {
    columns: [
        {
            name: "Registration Date",
            fieldName: "registrationDate",
            colType: GridColumnType.DATE,
            // colStyle: {
            //     width: "15%",
            //     textAlign: "center",
            //     color: "color",
            //     backgroundColor: "white"
            // },
            colSettings: {
                format: "DD-MMM-YYYY"
            },
            allowShort: false,
        },
        {
            name: "Invoice No",
            fieldName: "invoiceNo",
            allowShort: false,
            // colStyle: {
            //     width: "15%",
            //     textAlign: "center",
            //     color: "color",
            //     backgroundColor: "white"
            // }
        },
        {
            name: "Name",
            fieldName: "name",
            allowShort: false,
            // colStyle: {
            //     width: "15%",
            //     textAlign: "center",
            //     color: "color",
            //     backgroundColor: "white"
            // }
        },
        {
            name: "Payment Via",
            fieldName: "paymentVia",
            allowShort: false,
            // colStyle: {
            //     width: "15%",
            //     textAlign: "center",
            //     color: "color",
            //     backgroundColor: "white"
            // }
        },
        {
            name: "Status",
            fieldName: "statusName",
            allowShort: false,
            // colStyle: {
            //     width: "15%",
            //     textAlign: "center",
            //     color: "color",
            //     backgroundColor: "white"
            // }
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: true,
            },
            allowShort: false
        },
    ],
    allowEdit: false,
    isRowSelectable: true,
    hasChildGridTable: false,
    gridStyle: {
        tableClass: "border-table-simple"
    }
}

export const OutStandingInvoiceListConfig = {
    columns: [
        {
            name: "Invoice No",
            fieldName: "invoiceNo",
            allowShort: false,
        },
        {
            name: "Payment",
            fieldName: "paymentMethodName",
            allowShort: false,
        },
        {
            name: "Totoal Amount",
            fieldName: "totalAmount",
            allowShort: false,
        },
        {
            name: "Status",
            fieldName: "paymentStatus",
            allowShort: false,
        },
        {
            name: "Date",
            fieldName: "invoiceDate",
            colType: GridColumnType.DATE,
            colSettings: {
                format: "DD-MMM-YYYY"
            },
            allowShort: false,
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                // allowDelete: true,
            },
            allowShort: false
        },
    ],
    allowEdit: false,
    isRowSelectable: true,
    hasChildGridTable: false,
    gridStyle: {
        tableClass: "border-table-simple"
    }
} 